import React, { useEffect } from 'react';
import { Input } from 'reactstrap';
import { useParams } from 'react-router-dom';
import format from 'date-fns/format';
import withLoader from 'components/organisms/withLoader';
import { API_GOALS } from 'services/dataService/ccmResources';
import Pagination from 'components/molecules/paginationTransition';
import { showResult } from 'utils';
import useTable from 'utils/useTable';
import common from 'constants/common';
import * as Yup from 'yup';
import useValidation from 'utils/useValidation';
import classNames from 'classnames';
import TableActions from '../components/tableActions';

const validateAndSaveChanges =
  (validateRow, saveData, reloader) => async () => {
    const result = await validateRow();
    if (result.isValid) {
      const { error } = await saveData();
      if (error) showResult(error);
      else showResult();
      reloader();
    }
  };
const PER_PAGE = 5;
const DATE_FORMAT = common.dateFormats.full;
const VALIDATION_RULES = Yup.object().shape({
  log: Yup.string().required(),
  type: Yup.string().required(),
});
const createRow = () => ({
  goalDateTime: new Date(),
  type: 'personal',
  log: '',
});

const PersonalGoals = () => {
  const { patientGuid } = useParams();
  const { row, setRow, isValid, validate, messageErrors } = useValidation(
    {},
    VALIDATION_RULES,
  );
  const createNewRow = () => {
    setRow(createRow());
  };
  const clearRows = () => setRow({});
  const {
    data: { items },
    count,
    loading,
    saveLoading,
    page,
    setPage,
    setFilters,
    saveNewRow,
  } = useTable(
    API_GOALS,
    PER_PAGE,
    {
      patientGuid,
      type: 'personal',
    },
    { makeInitialRequest: false },
  );
  const rowIsSaved = !Object.keys(row).length;

  useEffect(() => {
    setFilters({ patientGuid, type: 'personal' });
    clearRows();
  }, [patientGuid]);
  return (
    <>
      <h4 className="ccm-table-section__h4">Personal Goals</h4>
      {withLoader(
        loading,
        <>
          <div className="table-outer table-custom-scrollbar">
            <table cellSpacing="0" cellPadding="0" className="table-border">
              <thead>
                <tr>
                  <th>Date/Time</th>
                  <th>Care Agent</th>
                  <th>Log</th>
                </tr>
              </thead>
              <tbody>
                {!!items.length &&
                  items.map((el, index) => (
                    <tr key={index}>
                      <td>{format(new Date(el.createdAt), DATE_FORMAT)}</td>
                      <td>
                        {el.author.title} {el.author.firstName}{' '}
                        {el.author.lastName} - {el.author.profession}
                      </td>
                      <td>{el.log}</td>
                    </tr>
                  ))}
                {!rowIsSaved && (
                  <>
                    <tr>
                      <td
                        colSpan={3}
                        className={classNames({
                          'table-column__input': true,
                        })}
                      >
                        <div>
                          <div className="table-column__input-container">
                            <Input
                              type="textarea"
                              className={classNames({
                                'is-invalid': !row.log && !isValid,
                              })}
                              bsSize="sm"
                              defaultValue={row.log}
                              onChange={(e) =>
                                setRow({
                                  ...row,
                                  log: e.target.value,
                                })
                              }
                            />
                            {row.log && (
                              <div className="table-column__character-length">
                                Character Count: {row.log.length}
                              </div>
                            )}
                          </div>
                          {messageErrors.log ? (
                            <div className="table-column__error">
                              {messageErrors.log}
                            </div>
                          ) : null}
                        </div>
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>
          {!saveLoading && (
            <TableActions
              save={validateAndSaveChanges(
                validate,
                () =>
                  saveNewRow(API_GOALS, {
                    ...row,
                    patientGuid,
                  }),
                clearRows,
              )}
              cancel={clearRows}
              new={createNewRow}
              rowIsSaved={rowIsSaved}
            />
          )}
          <div className="ccm-table-section__pagination">
            <Pagination
              title=""
              page={page}
              pageTotal={items.length}
              itemsPerPage={PER_PAGE}
              total={count}
              handleFirstClick={() => setPage(1)}
              handleLastClick={() => setPage(Math.ceil(count / PER_PAGE))}
              handlePrevClick={() => setPage(page - 1)}
              handleNextClick={() => setPage(page + 1)}
              handleGoToPage={(numberPage) => setPage(numberPage)}
            />
          </div>
        </>,
      )}
    </>
  );
};

export default PersonalGoals;
